import { render, staticRenderFns } from "./TemplateCardV3.vue?vue&type=template&id=6feea9f2&scoped=true&"
import script from "./TemplateCardV3.vue?vue&type=script&lang=js&"
export * from "./TemplateCardV3.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardV3.vue?vue&type=style&index=0&id=6feea9f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feea9f2",
  null
  
)

export default component.exports